import React from 'react';
import { createSlice } from '@reduxjs/toolkit';

type ErrorReporterFunction = (error: Error) => void;
type MessageReporterFunction = (message: string) => void;

export let reportError: ErrorReporterFunction = () => {};
export let reportMessage: MessageReporterFunction = () => {};

export const setErrorReporter = (reporter: ErrorReporterFunction) => {
  reportError = reporter;
};

export const setMessageReporter = (reporter: MessageReporterFunction) => {
  reportMessage = reporter;
};

export interface IErrorState {
  error: string | null;
}

const initialState: IErrorState = {
  error: null,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    handleErrorAction: (state, action) => {
      state.error = action.payload;
    },
    clearErrorAction: state => {
      state.error = null;
    },
  },
});

export type ErrorActions =
  | ReturnType<typeof errorSlice.actions.handleErrorAction>
  | ReturnType<typeof errorSlice.actions.clearErrorAction>;

export const { handleErrorAction, clearErrorAction } = errorSlice.actions;
export class ErrorBoundary extends React.Component<React.PropsWithChildren> {
  componentDidCatch(error: Error) {
    reportError(error);
  }

  render() {
    return this.props.children;
  }
}

export const errorReducer = errorSlice.reducer;
